export const LOGIN_HEADER_STRINGS = {
  platformName: 'Licensing Management Platform',
} as const
